<!--
   Created by qing on 2020/1/15 9:09 下午
   Des: 漏斗图
-->
<template>
  <div
    v-if="value && value.length"
    class="statistics__funnel"
    ref="funnel">
  </div>
  <div
    v-else
    :key="emptyKey"
    class="dashboard-empty__container">
    <i class="iconfont icon-nodata"></i>
    <div>暂无数据</div>
  </div>
</template>

<script>
  import {clone, findArrayMax, formatNum} from "../../../../assets/js/Untis"
  import current from "./mixin"

  export default {
    mixins: [current],
    data() {
      return {
        emptyKey: Math.random(),
        optConf: {
          tooltip: {
            trigger: 'item',
            formatter: '{b} <br/> {c} ({d}%)'
          },
          legend: {},
          series: null  /*
           {
              type: 'pie',
              radius: '65%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              data: [
                {value: 1548, name: '幽州'},
                {value: 535, name: '荆州'},
                {value: 510, name: '兖州'},
                {value: 634, name: '益州'},
                {value: 735, name: '西凉'}
              ]
            }
            * */
        },
        chart: null,
        loaded: false,
      }
    },
    computed: {},

    mounted() {
        if (this.$refs.funnel) {
          const chart = this.$ECharts.init(this.$refs.funnel)
          chart.title = ''
          this.chart = chart
          this.initChart()
        }

    },
    methods: {
      initChart() {
        this.$nextTick(() => {
          if (!this.chart && this.$refs.funnel) {
            const chart = this.$ECharts.init(this.$refs.funnel)
            chart.title = ''
            this.chart = chart
          }
          if (this.value && this.chart) {
            const opt = clone(this.optConf)
            opt.color = this.showPropertiesHolder.theme.value
            const showFieldsColor = this.showPropertiesHolder.showFieldsColor
            const colors = this.showPropertiesHolder.colors ? this.showPropertiesHolder.colors : []
            const value = this.value

            if (value && value.length) {
              opt.series = {
                type: 'funnel',
                left: '10%',
                top: 60,
                bottom: 60,
                width: '80%',
                min: 0,
                max: 100,
                minSize: '0%',
                maxSize: '100%',
                sort: 'descending',
                gap: 2,
                label: {
                  show: true,
                  position: 'inside'
                },
                labelLine: {
                  length: 10,
                  lineStyle: {
                    width: 1,
                    type: 'solid'
                  }
                },
                emphasis: {
                  label: {
                    fontSize: 20
                  }
                },
              }

              const max = findArrayMax(value.map(item => item.yAxis.value))
              opt.series.data = value.map((item, idx) => {

                let color = ''
                if (this.chartPropertiesHolder.showFields.length > 1) {
                  if (showFieldsColor[item.xAxis.dataId]) {
                    color = showFieldsColor[item.xAxis.dataId]
                  } else {
                    color = showFieldsColor[item.xAxis.dataId] = opt.color[idx] || opt.color[0]
                  }
                } else {
                  const colorItem = colors.filter(c => c.name === item.xAxis.value.showValue)[0]
                  color = colorItem ? colorItem.color : opt.color[idx] || opt.color[0]
                }
                return {
                  id: item.xAxis.dataId,
                  name: item.xAxis.value.showValue,
                  value: item.yAxis.value / max * 80,
                  itemStyle: {
                    color
                  }
                }
              })

              // 显示图例配置
              if (this.showPropertiesHolder.showLegend) {
                opt.legend = this.showPropertiesHolder.legend.value
                if (opt.legend) {
                  opt.legend.data = value.map(item => item.xAxis.value.showValue)
                }
              } else {
                opt.legend = null
              }

              // 显示数据标签
              if (!this.showPropertiesHolder.showDataTag) {
                opt.series.itemStyle = {
                  normal: {
                    label: {
                      show: false   //隐藏标示文字
                    },
                    labelLine: {
                      show: false   //隐藏标示线
                    }
                  }
                }
              }

              opt.tooltip = {
                trigger: 'item',
                formatter: (params) => {
                  var data = params.data;
                  var val = parseInt(data.value);

                  let field = this.chartPropertiesHolder.showFields.filter(field => field.idx === data.id)[0]
                  if (!field) {
                    field = this.chartPropertiesHolder.showFields[0]
                  }
                  if (field && field.tp) {
                    val = formatNum(data.value)
                  }

                  return data.name + '<br/>' + val + '(' + params.percent + '%)'
                },
                // formatter: '{b} <br/> {formatNum(c)} ({d}%)'
              }

              this.chart.setOption(opt, true, false, true)
              this.resize()
            } else {
              this.chart.clear()
              this.emptyKey = Math.random()
              this.chart = null
            }
            this.chart.on('click', params => {
              console.log('click',params)
              this.showDataDrillDownList(params)
            });
          }
        })
      },
      // 重置或初始化图表实例
      resize() {
        this.$nextTick(() => {
          if (this.chart) {
            this.chart.resize()
          }
        })
      }
    },
    components: {},
    watch: {
      // value 发生修改时 重新渲染图表
      value() {
        this.initChart()
      }
    }
  }
</script>

<style lang="less">
  .statistics__funnel {
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
